/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types typedef-whitespace */
import {
  AfterViewInit,
  Component,
  OnDestroy,
  ViewChild
}                                from '@angular/core';

import {Scenario}                from '@/models/scenario/scenario';
import {Logger}                  from '@/util/logger';
import {UnDoRedo}                from '@/util/un.do.redo';
import {WorkBloxEditor}          from '@/screens/ide/workblox/work.blox.editor';
import {WorkBloxSummaryGraph}    from '@/screens/ide/workblox/work.blox.summary.graph';
import {WorkBloxSummaryTable}    from '@/screens/ide/workblox/work.blox.summary.table';
import {WorkBlockChange}         from '@/screens/ide/workblox/work.block.change';
import {WorkBlockInlineEdit}     from '@/screens/ide/workblox/work.block.inline.edit';
import { BlobService }           from '@/services/blob.service';
import { AlertService          } from '@/services/alert.service';
import {ICommand}                from '@/util/i.command';
import {AddWorkBlockCommand}     from '@/screens/ide/workblox/add.work.block.command';
import {DeleteWorkBlockCommand}  from '@/screens/ide/workblox/delete.work.block.command';
import {BlobType}                from '@/models/blob';

import {WorkBlockSchema}         from '@/models/scenario/work.block.schema';
import {Tabs}                    from '@/components/tabs';

import KeyDownEvent = JQuery.KeyDownEvent;

import * as $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {
  BehaviorSubject,
  Subscription
}                                from 'rxjs';
import {first}                   from 'rxjs/operators';
import {basename, empty} from "@/util/util";
import {StatusReporter} from "@/util/status.reporter";


@Component({
  selector: 'work-blox-editor-component',
  template: `

    <!-- the work blox loader drop down -->
    <div class="wb-loader-wrapper" (click)="$event.stopPropagation();">

      <div
        class="wb-expander"
        (click)="toggleLoader()"
        [class.disabled]="scenarioKey !== ''"
        [innerHTML]="expanderElement"
        title="Select Scenario">
      </div>

      <div
        class="wb-save-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '')  || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="saveScenario()"
        [innerHTML]="saveScenarioElement"
        title="Save Scenario">
      </div>
      <div
        class="wb-download-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '')  || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="downloadScenario()"
        [innerHTML]="downloadScenarioElement"
        title="Download Scenario">
      </div>
      <div
        class="wb-clear-input"
        [class.disabled]="!hasInput()"
        [class.editorbusy]="editorBusy"
        (click)="clearCurrentInput()"
        [innerHTML]="clearWorkElement"
        title="Clear input data">
      </div>
      <div
        [ngClass]="{'wb-add-block': true, 'disabled': !canAdd()}"
        (click)="addNewWorkBlock()"
        [class.editorbusy]="editorBusy"
        [innerHTML]="addWorkElement"
        title="Add new work block"></div>
      <div
        class="wb-delete-block"
        [class.disabled]="!isDeletable()"
        [class.editorbusy]="editorBusy"
        (click)="deleteWorkBlock()"
        [innerHTML]="deleteWorkElement"
        title="Delete work block"></div>
      <div
        class="wb-undo"
        [class.disabled]="undoManager.undoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="undo()"
        [innerHTML]="undoElement"
        title="Undo last change"></div>
      <div
        class="wb-redo"
        [class.editorbusy]="editorBusy"
        [class.disabled]="undoManager.redoSize() === 0"
        (click)="redo()"
        [innerHTML]="redoElement" title="Redo last change"></div>

      <div class="wb-loader-panel" [class.expanded]="loaderActive">
        <div id="wb-loader-form-drop-area_{{u}}" class="wb-loader-form-drop-area drop-area">

            <p>To select a new scenario, drop a scenario on this dashed area, or click Browse.</p>
            <input
              (change)="onFileBrowse($event.target.files); $event.stopPropagation(); false"
              type="file"
              id="wb-loader-upload_{{u}}"
              class="wb-loader-upload"
              style="display: none !important;">

          <label
              class="gui-button primary"
              for="wb-loader-upload_{{u}}"
              (click)="browseClick($event); $event.stopPropagation(); false">
              Browse
            </label>

        </div>

        <div class="wb-scenario-name">
          <span class="wb-scenario-label">Scenario:</span>
          <span class="wb-scenario-title" [innerHTML]="scenarioTitle"></span>
        </div>


        <div *ngIf="errorLine!==''" id="wb-scenario-error_{{u}}" class="wb-scenario-error" [innerHTML]="errorLine">
        </div>

      </div>
    </div>

    <!-- outer shell for the work blox editor -->
    <div class="work-blox-editor-shell" style="text-align:center">
      <work-blox-editor
        (edit)="onEdit($event)"

        uuid={{u}}
        id="wb_st_{{u}}">

      </work-blox-editor>
    </div>

    <!-- outer shell for the work blox summaries -->
    <div class="work-blox-editor-summary-shell" style="text-align:center">
      <tabs>
        <tab title="Summary">
          <work-blox-summary-table  uuid={{u}} id="wb_st_{{u}}"></work-blox-summary-table>
        </tab>
        <tab title="Graph">
          <work-blox-summary-graph  uuid={{u}} id="wb_sg_{{u}}"></work-blox-summary-graph>
        </tab>
      </tabs>
    </div>
  `
})

export class WorkBloxEditorComponent implements AfterViewInit, OnDestroy, StatusReporter {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum:     number = 0;
  public u: number = WorkBloxEditorComponent.instanceNum;

  /** the history manager for the workblox editor */
  public undoManager:           UnDoRedo = new UnDoRedo(`WorkBloxHistory`);

  /** hint for window title, whatever we have for the basename of the scenario file */
  public           fileName: string      = '';

  /** the currently active row/selection/workblock */
  private selectedWorkBlock: BehaviorSubject<WorkBlockChange>;
  private selectSub:        Subscription = null;

  /** the most recent inline edit (single field) */
  private lastInlineEdit: BehaviorSubject<WorkBlockInlineEdit>;
  private editSub:          Subscription = null;

  /** track when the file drop area panel is shown */
  public  loaderActive:         boolean  = false;

  /** the content to show for the expand collapse button */
  public expanderElement:         string = '<i class="fas fa-angle-down"></i>';

  public clearWorkElement:        string = '<i class="fas fa-ban"></i>';
  public addWorkElement:          string = '<i class="fas fa-plus"></i>';
  public deleteWorkElement:       string = '<i class="far fa-trash-alt"></i>';
  public undoElement:             string = '<i class="fas fa-undo"></i>';
  public redoElement:             string = '<i class="fas fa-redo"></i>';
  public saveScenarioElement:     string = '<i class="far fa-save"></i>';
  public downloadScenarioElement: string = '<i class="fas fa-file-download"></i>';

  /** set to true when actions should be blocked because the editor is busy */
  public editorBusy:              boolean = false;

  /* the visible name of the scenario being browsed */
  public   scenarioTitle:         string = '';

  /* the error feedback if required */
  public       errorLine:         string = '';

  /* the current scenario model */
  public       scenario:        Scenario = null;

  /* the object version of the JSON used to load the scenario */
  public           json: any;

  /* blob key of scenario if it was loaded from a blob */
  public    scenarioKey:          string = '';

  @ViewChild(WorkBloxEditor, {static: false})
  public         editor: WorkBloxEditor;

  @ViewChild(WorkBloxSummaryTable, {static: false})
  public table: WorkBloxSummaryTable;

  @ViewChild(WorkBloxSummaryGraph, {static: false})
  public graph: WorkBloxSummaryGraph;

  @ViewChild(Tabs, {static: false})
  private tabs: Tabs;

  /* general call back for when we reload */
  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private blobber: BlobService,
    private alerts:  AlertService
  ) {

    Logger.debug('[workblox] dynamically creating...');

    /* setup an observable selection that every one can subscribe to */

    this.selectedWorkBlock = new BehaviorSubject<WorkBlockChange>(null);

    this.selectSub = this.selectedWorkBlock.subscribe( (next: WorkBlockChange) => {

      this.selected(next);
    });

    /* setup an observable for the inline edits */

    this.lastInlineEdit = new BehaviorSubject<WorkBlockInlineEdit>(null);

    this.editSub = this.lastInlineEdit.subscribe( (next: WorkBlockInlineEdit) => {

      this.inlineEdited(next);
    });

  }

  /** StatusReporter */
  status(text: string): void {

    if (this.editor) {

      this.editor.status(text);
    }

    Logger.info(`[workblox] ${text}`);
  }
  /** @brief publish an error message */
  error(text: string): void {

    if (this.editor) {

      this.editor.error(text);
    }

    Logger.error(`[workblox] ${text}`);
  }

  /** @brief publish a success message */
  success(text: string): void {

    if (this.editor) {

      this.editor.success(text);
    }

    Logger.debug(`[workblox] ${text}`);
  }

  /** handle single column changes in the editing inputs */
  public inlineEdited(edit: WorkBlockInlineEdit) {

    Logger.debug('[workblox] inline edit', edit);

    /* TODO: */

  }

  /** handle changes to which work block is selected */
  public selected(change: WorkBlockChange) {

    Logger.debug('[workblox] selection change', change);

    /* TODO: */



  }

  /** check if we have any input in the editing fields */
  public hasInput(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.hasInput();
  }

  /** check if the current editing input is a wor/WorkBlock that we can delete */
  public isDeletable(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.isDeletable();
  }

  /** check to see if the current editing input is good enough to add as a new WorkBlock */
  public canAdd(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if ((this.scenario === null) || (this.editor === null)) {

      return false;
    }

    return this.editor.isValid();
  }

  ngOnDestroy(): void {

    if (this.selectSub !== null) {

      /* unsubscribe our observer */

      this.selectSub.unsubscribe();
    }
  }

  ngAfterViewInit(): void {

    $('work-blox-editor-component').keydown((e: KeyDownEvent) => {

      if (e.key.toLowerCase() === 'escape') {

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

      if (e.ctrlKey && (e.key.toLowerCase() == 'v')) {

        /* add */

        this.addNewWorkBlock();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'x')) {

        /* delete */

        this.deleteWorkBlock();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'z')) {

        /* undo */

        this.undo();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'y')) {

        /* redo */

        this.redo();

        e.preventDefault();
        e.stopPropagation();

        return false;
      }
    });

    /* get the scenario drop box */

    const instanceId: string = `wbec_${this.u}`;

    Logger.debug(`[workblox] setting up drop zone..., instance id=${instanceId}...`);

    /* - - - - - -  add in drag n' drop behaviors */

    /* get the drop box */

    const dropArea: HTMLElement = $(`#wb-loader-form-drop-area_${this.u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#wb-loader-form-drop-area_${this.u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#wb-loader-form-drop-area_${this.u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onFileBrowse(Array.from(dt.files));

    }, false);

    /* tell the sub-components what history manager to use */

    this.editor.setHistory(this.undoManager);
    this.table.setHistory(this.undoManager);
    this.graph.setHistory(this.undoManager);

    /* make sure next instance of editor is unique */

    WorkBloxEditorComponent.instanceNum++;
  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseClick(e: MouseEvent) {

    document.getElementById(`wb-loader-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** helper to convert the current scenario (and work blocks) into JSON string */
  public toText(): string {

    /*
     * hack alert; instead of writing the full serialization for the entire scenario and all the
     * various kinds of blocks inside it...we're just doing it incrementally, for now, use the
     * the exact JSON object we loaded...and just overwrite the 'workblocks' section.  Then,
     * stringify that whole JSON, and save / download that string.
     *
     * This minimizes what we can mess up, because we're only twitching teh workblocks part. There
     * may still be some conversion issues; because for example floating point numbers were read
     * in by the JSON parser built into the browser...which may...or may not...make the same
     * assumptions/implementation choices about parsing and outputing floating point numbers...we
     * have no control over that :(
     *
     */

    const     wbs: WorkBlockSchema = new WorkBlockSchema();
    const section:           any[] = wbs.render(Array.from(this.scenario.workBlocks().values()));

    if ( section === null) {

      Logger.error(`[workblox] can't convert to text: ${wbs.lastError}`);
      return null;
    }

    this.json.scenario['workblocks'] = section;

    Logger.debug(`[workblox] new scenario:`, this.json);

    return JSON.stringify(this.json);
  }

  public saveScenario() {

    if ((this.scenario === null) || (this.scenarioKey === '')  || !this.canAdd()) {

      Logger.debug('[workblox] can not save right now.');

      return ;
    }

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Saving scenario...");
    this.editorBusy = true;

    const text: string = this.toText();

    Logger.debug(`[workblox] saving (key='${this.scenarioKey}', sz=${text.length})...`);

    this.blobber.update(this.scenarioKey, text)
      .pipe(first())
      .subscribe(
        () => {

          this.success("Saving complete!");
          this.editorBusy = false;

          Logger.debug('[workblox] scenario saved.');

        },
        error => {

          this.editorBusy = false;
          this.error("Could not save: " + error);

          Logger.error('[workblox] can not save scenario: ', error);

          this.alerts.error(error.error.message, {autoClose: true});

        });
  }

  public downloadScenario() {

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Starting download...");

    this.editorBusy = true;

    const text: string = this.toText();

    if (text === null) {

      Logger.debug(`[workblox] could not convert to text.`);

      this.editorBusy = false;

      return ;
    }

    Logger.debug(`[workblox] downloading (sz=${text.length})...`);

    const type: BlobType = BlobType.Scenario;
    const mime: string   = 'application/json';

    let keyBase = this.scenarioKey.substring(this.scenarioKey.lastIndexOf('/') + 1);

    if (!keyBase || keyBase === '' ) {

      keyBase = this.scenarioKey;
    }

    /* make a downloadable blob... */

    const blob = new Blob([text], { type: mime });
    const url  = window.URL.createObjectURL(blob);

    /* setup a fake one-time link with the right download name and the blob attached as the download */

    const element: HTMLAnchorElement = document.createElement('a');
    element.href                     = url;
    element.download                 = keyBase || 'download';
    element.style.display            = 'none';

    document.body.appendChild(element);

    /* do it */

    element.click();

    /* clean up */

    document.body.removeChild(element);

    this.editorBusy = false;
  }

  public clearCurrentInput() {

    Logger.debug(`[workblox] clearing current input.`);

    this.editor.clear();

    this.table.clearSelection();
    this.graph.clearSelection();
  }

  public addNewWorkBlock() {

    if (!this.canAdd()) {

      Logger.error(`[workblox] can not add right now`);

      return ;
    }

    this.status('Adding block...');

    Logger.debug(`[workblox] adding new work block...`);

    /* convert current input/selection to a change object we can use with a history command */

    const add: WorkBlockChange = this.table.getSelection();

    add.src = this;

    const cmd: ICommand        = new AddWorkBlockCommand(add, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Added.');
  }

  public deleteWorkBlock() {

    if (!this.isDeletable()) {

      Logger.error(`[workblox] can not delete right now.`);
      return ;
    }

    this.status('Deleting block...');

    Logger.debug(`[workblox] deleting work block...`);

    /* convert current input/selection to a change object we can use with a history command */

    const del: WorkBlockChange = this.table.getSelection();

    del.src = this;

    const cmd: ICommand        = new DeleteWorkBlockCommand(del, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Deleted.');
  }

  public undo() {

    if (this.undoManager.undoSize() === 0) {

      Logger.error(`[workblox] can not undo right now.`);

      return ;
    }

    Logger.debug(`[workblox] undo ... `);

    this.undoManager.undo();
  }

  public redo() {

    if (this.undoManager.redoSize() === 0) {

      Logger.error(`[workblox] can not redo right now.`);

      return ;
    }

    Logger.debug(`[workblox] redo ... `);

    this.undoManager.redo();
  }

  /** react to the user browsing a local windows scenario file */
  public onFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File = files[0];

    this.fileName      = upload.name;

    Logger.debug('[workblox] setting scenario via file: ', upload);

    this.status('');

    /* read in the raw text */

    const reader       = new FileReader();

    reader.onerror     = (msg) => {

      this.status('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      this.fromText(String(text), this.fileName);

    };

    reader.readAsText(upload);
  }

  public fromText(text: string, key: string = '') {

    Logger.debug(`[workblox] loading from raw text (${key})...`);

    /* convert to JSON */

    const wbe: WorkBloxEditorComponent = this;
    wbe.scenarioKey = key;
    wbe.json        = null;

    wbe.fileName = '';

    if (!empty(key)) {

      wbe.fileName = basename(key);
    }

    try {

      wbe.json = JSON.parse(text);

    } catch (e) {

      Logger.error('[workblox] Can not parse scenario JSON: ' + e.getError());
      wbe.error('Can not parse scenario JSON: ' + e.getError());

      return ;
    }

    /* try to construct a new model */

    wbe.onScenarioLock('Building from JSON...');

    const newScenario: Scenario = new Scenario(wbe.json, null, wbe);

    wbe.onScenarioUnlock();

    if (!newScenario.isReady()) {

      Logger.error('[workblox] Could not read scenario: ' + newScenario.getError());
      wbe.status(`Can not build scenario from JSON.`);

      return ;
    }

    Logger.debug('[workblox] scenario created.');

    /* success */

    setTimeout( () => {

      wbe.setScenario(newScenario);

      if (wbe.loaderActive) {

        wbe.toggleLoader();

      }

      /* let any user of this component know that we have reloaded the view */

      wbe.reloaded();

    }, 600);

  }

  /** when the main editor does any edits, we have to refresh the summary views. */
  public onEdit(s: Scenario) {

  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    Logger.debug('[workblox] locking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    Logger.debug('[workblox] unlocking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  /** set the scenario using the given JSON */
  public setScenario(s: Scenario) {

    Logger.debug('[workblox] setting new scenario...');

    this.scenarioTitle = `[<i>${s._author}</i>] ${s._tag}`;
    this.scenario      = s;
    this.status('');

    /* set the "model" */

    this.editor.setScenario(this.scenario);
    this.editor.setSelectionSubject(this.selectedWorkBlock);
    this.editor.setInlineEditSubject(this.lastInlineEdit);

    /* tell the summary table there is a new set of work blocks */

    this.table.setScenario(this.scenario);
    this.table.setSelectionSubject(this.selectedWorkBlock);
    this.table.setInlineEditSubject(this.lastInlineEdit);

    /* let the summary table capture user input */

    this.table.inputCapture = (): WorkBlockChange => {

      return this.editor.captureInput();
    };

    /* let the summary table restore user input */

    this.table.inputRestore = (snapshot: WorkBlockChange): void => {

      this.editor.restoreInput(snapshot);
    };

    /* tell the summary graph there is a new set of work blocks */

    this.graph.setScenario(this.scenario);
    this.graph.setSelectionSubject(this.selectedWorkBlock);
    this.graph.setInlineEditSubject(this.lastInlineEdit);

  }

  /** open the scenario loader drop down panel (or close it) */
  public toggleLoader() {

    if (this.loaderActive) {

      /* collapse */

      this.loaderActive    = false;
      this.expanderElement = '<i class="fas fa-angle-down"></i>';

      return ;
    }

    /* expand */

    this.loaderActive    = true;
    this.expanderElement = '<i class="fas fa-angle-up"></i>';
  }

}
